import styled from 'styled-components';

export const Ie11BannerWrapper = styled.div.attrs({ role: 'status' })`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 7.5px 0;
  font-size: 13px;
  text-align: center;
  padding-right: 22.5px;
  background: ${props => props.theme.carvana.yellow.primary};

  a {
    color: ${props => props.theme.carvana.blue.primary};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 16px;
    padding-right: 0;
  }
`;

export const CloseIcon = styled.button.attrs({ 'aria-label': 'close' })`
  position: absolute;
  width: 10px;
  height: 10px;
  right: 10px;
  top: 10px;
  cursor: pointer;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    right: 15px;
    top: 21px;
    width: 14px;
    height: 14px;
  }
`;
